/**
 * 发货相关 API 接口
 * 对接后端物流发货功能
 */

import instance from './axios-instance';

/**
 * 发货 - 创建物流订单
 * @param {Object} params - 发货参数
 * @param {string} params.orderId - 订单ID
 * @param {string} params.logistics_product_code - 物流产品代码
 * @param {Object} params.shippingData - 发货数据
 * @returns {Promise<Object>} 发货结果
 */
export const shipOrder = async ({ orderId, logistics_product_code, shippingData }) => {
  const { data } = await instance.post('/api/v1/orders/ship', {
    orderId,
    logistics_product_code,
    shippingData,
  });
  return data;
};

/**
 * 获取物流轨迹
 * @param {string} trackingNumber - 物流追踪号
 * @returns {Promise<Object>} 物流轨迹信息
 */
export const getTracking = async (trackingNumber) => {
  const { data } = await instance.get(`/api/v1/orders/tracking/${trackingNumber}`);
  return data;
};

/**
 * 获取物流产品列表
 * @param {Object} params - 查询参数
 * @param {string} params.transport_mode - 运输方式
 * @returns {Promise<Object>} 物流产品列表
 */
export const getLogisticsProducts = async (params = {}) => {
  const { data } = await instance.post('/api/v1/logistics/products', {
    transport_mode: params.transport_mode || "1",
    _t: Date.now(),
  });
  return data;
};

/**
 * 预估运费
 * @param {Object} params - 预估参数
 * @param {string} params.productCode - 物流产品代码
 * @param {number} params.weight - 重量(kg)
 * @param {string} params.country - 目的国家
 * @returns {Promise<Object>} 费用估算
 */
export const estimateShippingCost = async (params) => {
  const { data } = await instance.post('/api/v1/logistics/estimate', {
    ...params,
  });
  return data;
};

/**
 * 取消物流订单
 * @param {string} orderId - 订单ID
 * @returns {Promise<Object>} 取消结果
 */
export const cancelShipOrder = async (params) => {
  const orderId = typeof params === 'string' ? params : params?.orderId;
  const cancelReason = typeof params === 'string' ? '' : params?.cancel_reason || params?.cancelReason || '';
  const { data } = await instance.post(`/api/v1/orders/cancel-ship/${orderId}`, {
    cancel_reason: cancelReason,
  });
  return data;
};

const shippingApi = {
  shipOrder,
  getTracking,
  getLogisticsProducts,
  estimateShippingCost,
  cancelShipOrder,
};

export default shippingApi;
